import { render, staticRenderFns } from "./set-up.vue?vue&type=template&id=a6e8807c&scoped=true"
import script from "./set-up.vue?vue&type=script&lang=js"
export * from "./set-up.vue?vue&type=script&lang=js"
import style0 from "./set-up.vue?vue&type=style&index=0&id=a6e8807c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e8807c",
  null
  
)

export default component.exports